import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import ToolTipContent from '../../Common/ToolTipContent/ToolTipContent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../locale/messages';
import onSubmit from './submit';
import validate from './validate';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { siteSettings } from '../../../actions/siteadmin/siteSettings';
import { api, logoUploadDir, faviconUploadDir, siteUrl, ogImageUploadDir } from '../../../config';
import { setLoaderComplete } from '../../../actions/loader/loader';
import { demoRestriction } from '../../../actions/demoRestriction';

import bt from '../../../components/commonStyle.css';
import s from './SiteSettingsForm.css';

const SiteSettingsForm = (props) => {
  const {
    handleSubmit,
    change,
    updateTempImages,
    logo,
    favicon,
    ogImage,
    loading,
    submitting,
    logoImageLoader,
    faviconImageLoader,
    ogImageLoader,
    demoRestriction,
    intl: { formatMessage },
  } = props;

  const successLogo = async (file, fromServer) => {
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await change('homeLogo', fromServer?.fileName);
    await updateTempImages('SiteSettings', 'homeLogo', fromServer?.fileName);
    setLoaderComplete('logoImageLoader');
  };

  const successFavicon = async (file, fromServer) => {
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await change('favicon', fromServer?.fileName);
    await updateTempImages('SiteSettings', 'favicon', fromServer?.fileName);
  };

  const successOgImage = async (file, fromServer) => {
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await change('ogImage', fromServer?.fileName);
  };


  return (
    <div>
      <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.siteSettings)}</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="siteSettingFormRow">
          {/* Logo */}
          <Col xs={12} sm={12} md={6} lg={6} xl={4} className={bt.space4}>
            <div className={s.profileImgSection}>
              <label className={bt.commonLabelText}>{formatMessage(messages.logo)}</label>
              <CommonImageDisplay loader={logoImageLoader} imageSrc={logo ? api.apiEndpoint + logoUploadDir + 'medium_' + logo : null} />
              <ImageUploadComponent
                className='commonSiteAdminDropzoneSpace'
                subTextClass={s.subText}
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
                loaderName="logoImageLoader"
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.svg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl: api.apiEndpoint + '/uploadLogoImage',
                }}
                success={successLogo}
              />
            </div>
          </Col>

          {/* Favicon */}
          <Col xs={12} sm={12} md={6} lg={6} xl={4} className={bt.space4}>
            <div className={s.profileImgSection}>
              <label className={bt.commonLabelText}>{formatMessage(messages.favIconlogoLabel)}</label>
              <CommonImageDisplay loader={faviconImageLoader} imageSrc={favicon ? siteUrl + faviconUploadDir + favicon : null} />
              <ImageUploadComponent
                className='commonSiteAdminDropzoneSpace'
                subTextClass={s.subText}
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
                loaderName="faviconImageLoader"
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.svg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl: siteUrl + '/uploadFavicon',
                }}
                success={successFavicon}
              />
            </div>
          </Col>

          {/* OG Image */}
          <Col xs={12} sm={12} md={6} lg={6} xl={4} className={bt.space4}>
            <div className={s.profileImgSection}>
              <label className={cx(bt.commonLabelText, 'svgImg')}>
                {formatMessage(messages.ogImageLabel)} <ToolTipContent label={formatMessage(messages.ogImageTooltip)} />
              </label>
              <CommonImageDisplay loader={ogImageLoader} imageSrc={ogImage ? api.apiEndpoint + ogImageUploadDir + 'medium_' + ogImage : null} />
              <ImageUploadComponent
                className='commonSiteAdminDropzoneSpace'
                subTextClass={s.subText}
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
                loaderName="ogImageLoader"
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.svg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl: api.apiEndpoint + '/uploadOgImage',
                }}
                success={successOgImage}
              />
            </div>
          </Col>
        </Row>
        {/* Text Fields */}
        <div className='twoColumnGrid'>
          <Field
            name="siteName"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.siteName)}
            inputClass={bt.formControlInput}
            placeholder={formatMessage(messages.siteName)} />

          <Field
            name="siteTitle"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.siteTitle)}
            placeholder={formatMessage(messages.siteTitle)}
            inputClass={bt.formControlInput} />

          <Field
            name="metaKeyword"
            component={InputFieldComponent}
            label={formatMessage(messages.metakey)}
            placeholder={formatMessage(messages.metakey)}
            inputClass={bt.formTextArea}
            componentClass="textarea"
          />

          <Field
            name="metaDescription"
            component={InputFieldComponent}
            label={formatMessage(messages.metaDesc)}
            placeholder={formatMessage(messages.metaDesc)}
            inputClass={bt.formTextArea}
            componentClass="textarea"
          />

          <Field
            name="facebookLink"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.facebookURL)}
            placeholder={formatMessage(messages.facebookURL)}
            inputClass={bt.formControlInput} />

          <Field
            name="twitterLink"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.xURL)}
            placeholder={formatMessage(messages.xURL)}
            inputClass={bt.formControlInput} />

          <Field
            name="instagramLink"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.instagramURL)}
            placeholder={formatMessage(messages.instagramURL)}
            inputClass={bt.formControlInput} />

          <Field
            name="youtubeLink"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.youtubeURL)}
            placeholder={formatMessage(messages.youtubeURL)}
            inputClass={bt.formControlInput} />
        </div>
        <div className="commonButtonContainer">
          <Loader
            type="button"
            label={formatMessage(messages.submitButton)}
            show={loading}
            buttonType="submit"
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting || loading}
          />
        </div>
      </form>
    </div>
  );
};

const formWrapped = reduxForm({
  form: 'SiteSettingsForm',
  onSubmit,
  validate,
})(SiteSettingsForm);

const selector = formValueSelector('SiteSettingsForm');

const mapState = (state) => ({
  logo: selector(state, 'homeLogo'),
  favicon: selector(state, 'favicon'),
  ogImage: selector(state, 'ogImage'),
  appForceUpdate: selector(state, 'appForceUpdate'),
  loading: state?.loader?.SiteSettings,
  logoImageLoader: state?.loader?.logoImageLoader,
  faviconImageLoader: state?.loader?.faviconImageLoader,
  ogImageLoader: state?.loader?.ogImageLoader,
});

const mapDispatch = {
  siteSettings,
  change,
  updateTempImages,
  demoRestriction
};

export default injectIntl(
  withStyles(bt, s)(connect(mapState, mapDispatch)(formWrapped))
);
